import { 
  LOAD_USER_DATA_IN_PROGRESS,
  LOAD_USER_DATA_SUCCESS,
  LOAD_USER_DATA_FAILURE,
  OPEN_USER_DIALOG,
  CLOSE_USER_DIALOG,
  USER_OPERATION_COMPLETED,
  LOAD_USER_ROLE_DATA_SUCCESS,
  LOAD_USER_PERMISSIONS_DATA_SUCCESS,
  LOAD_APP_USER_DATA_SUCCESS
} from "./actions";

const initialState = { isLoading: false, userListdata: [], rolesData:[], userPermissionsData: [], appUserdata:[]};

export const userData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_USER_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        userListdata: data,
      };
    }
    case LOAD_USER_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_USER_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case USER_OPERATION_COMPLETED:
      return {
        ...state,
        isLoading: false,
      }; 

    case OPEN_USER_DIALOG:
      return {
        ...state,
        isUserDialogOpen: true,
      }; 

    case CLOSE_USER_DIALOG:
      return {
        ...state,
        isUserDialogOpen: false,
      };

      case LOAD_USER_ROLE_DATA_SUCCESS: {
        const { data } = payload;
        return {
          ...state,
          rolesData: data,
        };
      }
      case LOAD_USER_PERMISSIONS_DATA_SUCCESS: {
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            userPermissionsData: data,
        };
      };
      case LOAD_APP_USER_DATA_SUCCESS: {
        const { data } = payload;
        return {
          ...state,
          isLoading: false,
          appUserdata: data,
        };
      }
      default:
        return state;
    }
  };
